import { render, staticRenderFns } from "./FormaRecebimentoList.vue?vue&type=template&id=24e2183f&scoped=true"
import script from "./FormaRecebimentoList.vue?vue&type=script&lang=js"
export * from "./FormaRecebimentoList.vue?vue&type=script&lang=js"
import style0 from "./FormaRecebimentoList.vue?vue&type=style&index=0&id=24e2183f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e2183f",
  null
  
)

export default component.exports